'use client';
import Image from 'next/image';
import Link from 'next/link';
import { VariantProps } from 'tailwind-variants';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';
import BrandSmileIcon from '@/fo/icons/base/specials/brand_smile.svg';

import { styles } from './UiKitSectionImportantProjects.styles';

export interface Image {
  id?: number;
  url?: string | null;
  alt?: string;
  createdAt?: string;
  filename?: string | null;
  updateAt?: string;
  filesize?: number | null;
  focalX?: number | null;
  focalY?: number | null;
  height?: number | null;
  mimeType?: string | null;
  thumbnailUrl?: string | null;
  width?: number | null;
}
export interface Page {
  id?: string | null;
  title: string;
  subtitle?: string | null;
  link: string;
  image: number | Image;
}

type ContentText = {
  mainTitle: string;
  mainDescription?: string | null;
  buttonHref?: string | null;
  buttonLabel?: string | null;
  pages?: Page[] | null;
};

type Variants = VariantProps<typeof styles>;
export interface UiKitSectionImportantProjectsProps {
  className?: string;
  content: ContentText;
  variant?: Variants['variant'];
}

export function UiKitSectionImportantProjects({
  content,
  className,
  variant
}: UiKitSectionImportantProjectsProps) {
  const slots = styles({ variant });

  return (
    <div className={slots.base({ className })}>
      <div className={slots.rowText()}>
        <div className={slots.main()}>
          <BrandSmileIcon className={slots.mainIcon()} />
          {content.mainTitle && (
            <p className={slots.mainTitle()}>{content.mainTitle}</p>
          )}
          {content.mainDescription && (
            <p className={slots.mainDescription()}>{content.mainDescription}</p>
          )}

          {content.buttonHref && content.buttonLabel && (
            <a
              href={content.buttonHref}
              className={slots.link()}
            >
              {content.buttonLabel}
              <ChevronIcon className={slots.linkIcon()} />
            </a>
          )}
        </div>

        <div className={slots.pages()}>
          <div className={slots.itemsList()}>
            {content.pages &&
              content.pages.map((item) => (
                <Link
                  key={item.id}
                  href={item.link}
                  className={slots.item()}
                >
                  {item.image && (
                    <Image
                      className={slots.itemImage()}
                      alt={(item.image as Image).alt || item.title}
                      width="200"
                      height="200"
                      src={(item.image as Image).url || ''}
                    />
                  )}
                  <div className={slots.info()}>
                    <p className={slots.title()}>{item.title}</p>
                    <p className={slots.subtitle()}>
                      {item.subtitle}
                      <ChevronIcon className={slots.arrowMobile()} />
                    </p>
                    <ChevronIcon className={slots.arrow()} />
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
